import {
  StrapiApiImage,
  StrapiApiImages,
  StrapiImage,
} from 'types/strapi/image'

export function flattenImage(image: StrapiApiImage | null): StrapiImage {
  if (!image || !image?.data || !image.data?.attributes) return null

  return {
    ...image.data.attributes,
  }
}

export function flattenImages(images: StrapiApiImages): StrapiImage[] {
  if (!images?.data) return []
  if (Array.isArray(images.data) && images.data.length === 0) return []

  const filteredImages = images.data.filter(image => !!image.attributes)

  return filteredImages.map(image => ({ ...image.attributes }))
}

export function isLocalProvider(image: StrapiImage) {
  if (image?.provider === 'local') return true

  return false
}

export function getFullImageUrl(image: StrapiApiImage): string | null {
  if (!image?.data?.attributes) return null
  const { url } = image.data.attributes
  if (url.startsWith('http')) return url

  return `${process.env.NEXT_PUBLIC_STRAPI_API_URL}${url}`
}
